// extracted by mini-css-extract-plugin
export default {"ErrorWrapper":"PreviewParsingError_ErrorWrapper__GBYVw"};